import React from "react";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import "@/App.css";

function App() {
    return (
        <div className="App grain-overlay">
            <Landing />
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#0D0D0D",
                        border: "2px solid #E5FF00",
                        color: "#ffffff",
                        borderRadius: 0,
                        fontFamily: "JetBrains Mono, monospace",
                    },
                }}
            />
        </div>
    );
}

export default App;
